import ApiStore from './ApiStore';
import AuthStore from './AuthStore';
import ModalStore from './ModalStore';
import UIStore from './UIStore';
import PublicationStore from './PublicationStore';
import MagazineStore from './MagazineStore';
import ReaderStore from './ReaderStore';
import SettingSystemStore from './SettingSystemStore';
import CartStore from './CartStore';
import ProfileStore from './ProfileStore';
import OrderStore from './OrderStore';
import GroupAdminStore from './GroupAdminStore';

export default class RootStore {
    modalStore: ModalStore;
    apiStore: ApiStore;
    uiStore: UIStore;
    authStore: AuthStore;
    publicationStore: PublicationStore;
    magazineStore: MagazineStore;
    readerStore: ReaderStore;
    settingSystemStore: SettingSystemStore;
    cartStore: CartStore;
    profileStore: ProfileStore;
    orderStore: OrderStore;
    groupAdminStore: GroupAdminStore;

    constructor() {
        this.modalStore = new ModalStore();
        this.apiStore = new ApiStore(this);
        this.uiStore = new UIStore(this);
        this.authStore = new AuthStore(this);
        this.publicationStore = new PublicationStore(this);
        this.magazineStore = new MagazineStore(this);
        this.readerStore = new ReaderStore(this);
        this.settingSystemStore = new SettingSystemStore(this);
        this.cartStore = new CartStore(this);
        this.profileStore = new ProfileStore(this);
        this.orderStore = new OrderStore(this);
        this.groupAdminStore = new GroupAdminStore(this);
    }
}
